import React, { useEffect, useRef, useState } from 'react'

import { TitleBarCenterContainer } from './__internal__/title-bar-center-container'
import { TitleBarIconButton } from './__internal__/title-bar-icon-button'
import { TitleBarLeftContainer } from './__internal__/title-bar-left-container'
import { TitleBarRightContainer } from './__internal__/title-bar-right-container'
import { TitleBarSubText } from './__internal__/title-bar-sub-text'
import { TitleBarSubTextContainer } from './__internal__/title-bar-sub-text-container'
import { TitleBarTitleText } from './__internal__/title-bar-title-text'

export function TitleBar({ children }: { readonly children: React.ReactNode }) {
  const stickyDetectorRef = useRef<HTMLDivElement>(null)

  const [stickyStatus, setStickyStatus] = useState<'not-stuck' | 'stuck'>(
    'not-stuck',
  )

  useEffect(function setupStickyDetector() {
    const stickyDetector = stickyDetectorRef.current

    /* v8 ignore if -- @preserve */
    if (stickyDetector === null) {
      return
    }

    // deno-lint-ignore no-undef
    const observer = new IntersectionObserver(([entry]) => {
      setStickyStatus(entry.isIntersecting ? 'not-stuck' : 'stuck')
    })

    observer.observe(stickyDetector)

    return () => {
      observer.disconnect()
    }
  }, [])

  return (
    <>
      <div ref={stickyDetectorRef} />
      <div
        className={`sticky top-0 bg-white grid grid-cols-[1fr_2fr_1fr] items-center mx-auto px-4 h-16 md:px-6 md:h-20 border-b transition-colors duration-100 ${
          stickyStatus === 'stuck'
            ? 'border-acorns-ivory'
            : 'border-transparent'
        }`}
      >
        {children}
      </div>
    </>
  )
}

TitleBar.LeftContainer = TitleBarLeftContainer
TitleBar.CenterContainer = TitleBarCenterContainer
TitleBar.RightContainer = TitleBarRightContainer
TitleBar.TitleText = TitleBarTitleText
TitleBar.SubTextContainer = TitleBarSubTextContainer
TitleBar.SubText = TitleBarSubText
TitleBar.IconButton = TitleBarIconButton
